
import { Component, Vue } from 'vue-property-decorator';
import Card from '@/components/dashboard/Card.vue';
import { mapActions, mapGetters } from 'vuex';
import { Sheet } from '@/model/Sheet';
import EventsSheetsLayout from '@/components/layout/EventsSheetsLayout.vue';

@Component({
    components: {
        Card,
        EventsSheetsLayout,
    },
    computed: {
        ...mapGetters({
            sheets: 'sheetStorage/getSheets',
        }),
    },
    methods: {
        ...mapActions({
            fetchSheets: 'sheetStorage/fetchSheets',
        }),
    },
})
export default class Sheets extends Vue {
    loading = false;

    fetchSheets!: () => Promise<void | Sheet[]>;

    onClick(token: number): void {
        this.$router.push(`sheet/${token}`);
    }

    mounted(): void {
        this.loading = true;
        this.fetchSheets().finally(() => {
            this.loading = false;
        });
    }
}
